// extracted by mini-css-extract-plugin
export default {"orders":"styles_orders__dl7Rv","ordersCounter":"styles_ordersCounter__J5UNY"};